import axios from "axios";
import * as Actions from "../actions/index"

const initialState = {
    //data
    meetingSession: null,
    MeetingOn: false,
    LoadingToStartAVideoSession: true,
    People: {},
    ScreenShareOn: false,
    Chat: [],
    IsHost: false,
    IsRomEnabled: false,
    SpecialBodyParts: [],
    ExerciseVideoShow: false,
    ExerciseVideoPoster: "",
    ExerciseVideoVideo: "",
    Specialities: [],
    SpecialThings: [],
    VideoSearch: [],
    RomParts: [],
    VideoTilesPeople: [],
    meetingUserId: null,
    HasLeftMeeting: true,
    localMuteOrNot: true,
    LocalUserName: "",
    SOAP: false,
    FavVideosList: [],
    IsPatientHashMap: {},
    SelectedVideoForROM: "",
    sypLogSummaryId: "",
    PatientID: "",
    PatientsList: [],
    ScreenShotImages: [],
    ScreenShotOpen: false,
    SelectedPatientID: "",
    LoaclUserID: "",
    PersonWhoIsSharingScreen: "",
    RomSession: {},
    RomFuture: [],
    ShowEnd: false,
    JoinedUserType: "",
    isVideoOn: true,
    ClinicLibary: [],
    PainLevel: "",
    FunctionalLevel: "",
    OtherNotes: ""

};

export const MeetingReducer = (state = initialState, action) => {

    const { type, payload } = action;

    switch (type) {
        case "RTM_NOTES":
            console.log(payload)
        return {
            ...state,
            PainLevel: payload.PainLevel,
            FunctionalLevel: payload.FunctionalLevel,
            OtherNotes: payload.OtherNotes
        };
        case "CAMERA_CONTROL":
            return {
                ...state,
                isVideoOn: payload === undefined || payload === null ? true : payload,
            }
        case "JOINED_USER_TYPE":
            return {
                ...state,
                JoinedUserType: payload,
            }
        case "THE_END":
            return {
                ...state,
                ShowEnd: true,
            }
        case Actions.SET_IS_HOST:
            return {
                ...state,
                isHost: payload,
            }
        case Actions.SAVING_ROM_FOR_FUTURE:
            return {
                ...state,
                RomFuture: [
                    ...payload,
                    ...state.RomFuture,

                ]
            }
        case Actions.CREATE_ROM_SESSION:
            return {
                ...state,
                RomSession: payload
            }
        case Actions.PERSON_WHO_IS_SHARING_SCREEN:
            return {
                ...state,
                PersonWhoIsSharingScreen: payload
            }
        case Actions.LOCAL_USER_ID:
            return {
                ...state,
                LoaclUserID: payload
            }
        case Actions.SELECTED_PATIENT_ID:
            return {
                ...state,
                SelectedPatientID: payload
            }
        case Actions.SCREENSHOT_OPEN:
            return {
                ...state,
                ScreenShotOpen: payload
            }
        case Actions.SAVE_SCREENSHOT:
            return {
                ...state,
                ScreenShotImages: [...state.ScreenShotImages, payload]
            }
        case Actions.UPDATING_PATIENTS_LIST:
            return {
                ...state,
                PatientsList: payload
            }
        case Actions.SELECTING_ROM_USER:
            return {
                ...state,
                SelectedVideoForROM: payload,
            }
        case Actions.DELETEING_USER_FROM_HASH_MAP:
            const IsPatientHashMap2 = state.IsPatientHashMap;

            for (const key in IsPatientHashMap2) {
                if (IsPatientHashMap2[key]) {
                    if (IsPatientHashMap2[key].UserID == payload) {
                        delete IsPatientHashMap2[key]
                    }
                }
            }
            return {
                ...state,
                IsPatientHashMap: IsPatientHashMap2
            }


        case Actions.UPDATING_IS_PATIENT_STATUS_FOR_THE_HOST:
            //payload

            const IsPatientHashMap = state.IsPatientHashMap;

            for (const key in IsPatientHashMap) {
                if (IsPatientHashMap[key]) {
                    if (IsPatientHashMap[key].UserID == payload) {
                        IsPatientHashMap[key].IsPatient = true
                        if (!state.SelectedVideoForROM) return {
                            ...state,
                            IsPatientHashMap,
                            SelectedVideoForROM: IsPatientHashMap[key].videoTile
                        }
                        return {
                            ...state,
                            IsPatientHashMap,
                        }
                    }

                }
            }
        case Actions.STORING_PATIETNS_ID_TITLE:
            const IsPatientHashMapNew = state.IsPatientHashMap;
            if (IsPatientHashMapNew[action.tileID]) return state
            return {
                ...state,
                IsPatientHashMap: {
                    ...state.IsPatientHashMap,
                    [action.tileID]: {
                        UserID: action.patientID,
                        IsPatient: false,
                        videoTile: action.videoTile
                    }
                }
            }
        case Actions.MY_FAVORITE_VIDEOS:
            return {
                ...state,
                FavVideosList: payload
            }
        case Actions.GET_CLINIC_LIBRARY:
            return {
                ...state,
                ClinicLibary: payload
            }
        case Actions.ENABLE_SOAP:
            return {
                ...state,
                SOAP: payload
            }
        case Actions.SAVE_USERS_NAME:
            return {
                ...state,
                LocalUserName: payload,
            }
        case Actions.LOCAL_MIC_MUTE_INDICATOR:
            return {
                ...state,
                localMuteOrNot: payload
            }
        case Actions.MEETING_LEFT:
            return {
                ...state,
                HasLeftMeeting: payload
            }
        case Actions.SAVING_MEETING_USER_ID:
            return {
                ...state,
                meetingUserId: payload.meetingUserId,
                sypLogSummaryId: payload.sypLogSummaryId,
                PatientID: payload.sheduledPatientId
            }
        case Actions.VIDEO_TILES_UPDATE:
            if (payload.add) {
                return {
                    ...state,
                    VideoTilesPeople: [...state.VideoTilesPeople, payload.ID]
                }
            }
            return {
                ...state,
                VideoTilesPeople: state.VideoTilesPeople.filter(x => x !== payload.ID)
            }
        case Actions.SETTING_MEETING_ON:
            return {
                ...state,
                MeetingOn: payload
            }
        case Actions.GETTING_ROM_PARTS:
            return {
                ...state,
                RomParts: payload
            }
        case Actions.VIDEOS_SEARCH:
            return {
                ...state,
                VideoSearch: payload
            }
        case Actions.SAVE_SPECIAL_STUFF:
            return {
                ...state,
                SpecialThings: payload
            }
        case Actions.SAVE_SPECIALITY:

            return {
                ...state,
                Specialities: payload
            }
        case Actions.SET_EXERCISE_VIDEO:
            return {
                ...state,
                ExerciseVideoShow: payload.show,
                ExerciseVideoPoster: payload.poster,
                ExerciseVideoVideo: payload.video,
            }
        case Actions.STORING_MEETING_SESSION:
            return {
                ...state,
                meetingSession: payload,
                LoadingToStartAVideoSession: false,
            }

        case Actions.GETTING_PEOPLE:
            return {
                ...state,
                People: payload,
            }
        case Actions.SCREEN_SHARE_ON:
            return {
                ...state,
                ScreenShareOn: payload,
            }
        case "CHAT":
            return {
                ...state,
                Chat: [...state.Chat, payload]
            }
        case Actions.STORING_HOST_DATA:
            return {
                ...state,
                IsHost: payload
            }
        case Actions.SET_ROM_ON_OFF:
            return {
                ...state,
                IsRomEnabled: payload
            }
        case Actions.SPECIAL_BODY_PARTS_LIST_FOR_MEETING:
            return {
                ...state,
                SpecialBodyParts: payload
            }
        case "CLEAN":
            return {
                meetingSession: null,
                MeetingOn: false,
                LoadingToStartAVideoSession: true,
                People: {},
                ScreenShareOn: false,
                Chat: [],
                IsHost: false,
                IsRomEnabled: false,
                SpecialBodyParts: [],
                ExerciseVideoShow: false,
                ExerciseVideoPoster: "",
                ExerciseVideoVideo: "",
                Specialities: [],
                SpecialThings: [],
                VideoSearch: [],
                RomParts: [],
                VideoTilesPeople: [],
                meetingUserId: null,
                HasLeftMeeting: true,
                localMuteOrNot: true,
                LocalUserName: "",
                SOAP: false,
                FavVideosList: [],
                IsPatientHashMap: {},
                SelectedVideoForROM: "",
                sypLogSummaryId: "",
                PatientID: "",
                PatientsList: [],
                ScreenShotImages: [],
                ScreenShotOpen: false,
                SelectedPatientID: "",
                LoaclUserID: "",
                PersonWhoIsSharingScreen: "",
                RomSession: {},
                RomFuture: []
            }
        default:
            return state;
    }
}

